import React from "react";
import { Box, Typography } from "@mui/material";
import PopupModal from "../../shared/PopupModal";
import DemoInputInfoLink from "./DemoInputInfoLink";
import {
  goToDemoSignup,
  DEMO_LOCKED_FROM_STEP_LABEL,
} from "../utils/demoConstants";

// デモ（TOPページ埋め込み）で「一時保存」またはロックされた step を押したときに出す本登録誘導モーダル。
// reason: "save" … 一時保存を押した / "locked" … ロックされた step を押した
// タイトルだけ出し分け、本文（intro / 注意事項 / リンク）は共通。
const TITLE = {
  save: "入力内容を保存するには本登録が必要です",
  locked: `Step ${DEMO_LOCKED_FROM_STEP_LABEL} 以降は本登録が必要です`,
};

const INTRO = (
  <>
    本登録すると、このブラウザに保存されたデモ入力内容を「デモプロジェクト」として登録できます。
    <br />
    入力は空欄や途中の状態でも問題ありません。
  </>
);

const NOTES = [
  "入力内容は、この端末・ブラウザに保存されます",
  "PDF生成時を除き、デモ利用中は当社サーバーへ送信されません",
  "別端末・別ブラウザには引き継げないため、同じ端末・同じブラウザで本登録してください",
  "本登録が完了すると、デモ入力内容は「デモプロジェクト」としてDBへ保存されます",
  "通常の新規登録画面から登録した場合は、デモ入力内容を引き継ぎません",
];

export default function DemoRegisterModal({ open, onClose, reason = "save" }) {
  const title = TITLE[reason] || TITLE.save;

  return (
    <PopupModal
      open={open}
      onClose={onClose}
      onConfirm={goToDemoSignup}
      title={title}
      confirmLabel="本登録して内容を引き継ぐ"
      cancelLabel="デモ入力を続ける"
    >
      <Typography sx={{ fontSize: "0.875rem", mb: 1.5 }}>{INTRO}</Typography>
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          pl: 0,
          m: 0,
          fontSize: "0.8125rem",
          color: "#4b5563",
        }}
      >
        {NOTES.map((note) => (
          <Box
            component="li"
            key={note}
            sx={{
              position: "relative",
              pl: "1.2em",
              mb: 0.5,
              // LP 側のリセット（.top li { list-style: none }）で ・ が消えるため自前で描画
              "&::before": {
                content: '"・"',
                position: "absolute",
                left: 0,
              },
            }}
          >
            {note}
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontSize: "0.75rem", mt: 2 }}>
        <DemoInputInfoLink />
      </Typography>
    </PopupModal>
  );
}
